import { Formik, Form } from 'formik'
import SelectedLabTests from '@commons/categorySearch/selectedItems'
import SearchLabTests from '@commons/categorySearch/search'
import Column from '@components/column'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { StyleRow, StyleSearchWrapper, StyleSelectedCardWrapper } from './style'
import Button from '@components/button'
import { Appointment } from '@apis'
const LabTests = ({ canSave = true }) => {
  const { data: appointment } = useSelector(
    (state: any) => state.consultAppointment,
  )
  const [initialValues, setInitialValues] = useState({
    labTests: [],
  })
  const [loading, setLoading] = useState<boolean>(false)

  const submitHandler = async (values) => {
    setLoading(true)
    if (!values?.labTests?.length) {
      setLoading(false)
      return
    }
    await Appointment.update({
      data: {
        labTests: values?.labTests?.map((labTest: any) => labTest?.id),
      },
      id: appointment?.id,
      state: 'consultAppointment',
    }).catch(() => {})
    setLoading(false)
  }

  useEffect(() => {
    setInitialValues({
      labTests: appointment?.labTests,
    })
  }, [appointment?.id])
  return (
    <Column>
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
      >
        {({ handleSubmit, values, setFieldValue }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Column rowGap={20}>
                <StyleRow>
                  <StyleSelectedCardWrapper>
                    <SelectedLabTests
                      selectedItems={values?.labTests}
                      setFieldValue={setFieldValue}
                      name="labTests"
                      multiple={true}
                      error=""
                    />
                  </StyleSelectedCardWrapper>
                  <StyleSearchWrapper>
                    <SearchLabTests
                      setFieldValue={setFieldValue}
                      selectedItems={values?.labTests}
                      name="labTests"
                      multiple={true}
                      selector="labTestCategories"
                      type="LabTest"
                    />
                  </StyleSearchWrapper>
                </StyleRow>
                {!!canSave && (
                  <Column alignItems="flex-end">
                    <Button
                      title="Save"
                      type="submit"
                      height={40}
                      loading={loading}
                    />
                  </Column>
                )}
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Column>
  )
}

export default LabTests
